import { apiSlice } from './apiSlice';
import { STORESUPPLIES_URL } from '../constants';

export const storeSuppliesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new storeSupply
    createStoreSupply: builder.mutation({
      query: (storeSupply) => ({
        url: STORESUPPLIES_URL,
        method: 'POST',
        body: storeSupply,
      }),
      invalidatesTags: ['StoreSupplies'],
    }),

    // Get storeSupply details by ID
    getStoreSupplyDetails: builder.query({
      query: (id) => ({
        url: `${STORESUPPLIES_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, id) => [{ type: 'StoreSupply', id }],
    }),

    // Get logged-in user's storeSupplies
    getMyStoreSupplies: builder.query({
      query: () => ({
        url: `${STORESUPPLIES_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['MyStoreSupplies'],
    }),

    // Get all storeSupplies (Admin)
    getStoreSupplies: builder.query({
      query: () => ({
        url: STORESUPPLIES_URL,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['StoreSupplies'],
    }),

    // Mark a storeSupply as delivered
    deliverStoreSupply: builder.mutation({
      query: (storeSupplyId) => ({
        url: `${STORESUPPLIES_URL}/${storeSupplyId}/deliver`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, storeSupplyId) => [{ type: 'StoreSupply', id: storeSupplyId }],
    }),

    // Update a storeSupply (FIXED)
    updateStoreSupply: builder.mutation({
      query: ({ storeSupplyId, ...body }) => ({
        url: `${STORESUPPLIES_URL}/${storeSupplyId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['StoreSupplies'],
    }),

    // Upload multiple images
    uploadStoreSupplyImages: builder.mutation({
      query: (data) => ({
        url: `/api/upload`,
        method: 'POST',
        body: data,
      }),
    }),

    // Delete a storeSupply
    deleteStoreSupply: builder.mutation({
      query: (storeSupplyId) => ({
        url: `${STORESUPPLIES_URL}/${storeSupplyId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, storeSupplyId) => [
        { type: 'StoreSupply', id: storeSupplyId },
        'StoreSupplies',
      ],
    }),
  }),
});

export const {
  useCreateStoreSupplyMutation,
  useGetStoreSupplyDetailsQuery,
  useGetMyStoreSuppliesQuery,
  useGetStoreSuppliesQuery,
  useUpdateStoreSupplyMutation,
  useUploadStoreSupplyImagesMutation,
  useDeliverStoreSupplyMutation,
  useDeleteStoreSupplyMutation,
} = storeSuppliesApiSlice;
